import { Injectable } from '@angular/core';
import * as moment from 'moment';
import {extendMoment} from 'moment-range';
import { calendar } from 'ngx-bootstrap/chronos/moment/calendar';
import { PoOrderByPipe } from '../pipes/po-order-by.pipe';

@Injectable({
  providedIn: 'root'
})
export class DateHelperService {

  constructor(private pipe: PoOrderByPipe) { }


  compareMonthAndYear(fromDate: Date, toDate: Date) {

    let isEqualYear = false;
    let result = false;
    if (fromDate.getFullYear() === toDate.getFullYear()) {
      isEqualYear = true;
      if (isEqualYear) {
      if (fromDate.getMonth() <= toDate.getMonth()) {
        result = true;
      }
    }
    } else if (fromDate.getFullYear() <= toDate.getFullYear()) {
      result = true;
    }
    return result;
  }


  getSelectedWeeks(year, month) {
    console.log(year, month);
    let add = true;
    const startDate = moment([year, month]);

    // Get the first and last day of the month
    const firstDay = moment(startDate).startOf('month');
    const endDay = moment(startDate).endOf('month');

    // Create a range for the month we can iterate through

    const rangeMoment = extendMoment(moment);
    const monthRange = rangeMoment.range(firstDay, endDay);
  // const monthRange = MomentRange.extendMoment.range(firstDay, endDay);

    // Get all the weeks during the current month
    const weeks = [];
    for (const mday of monthRange.by('days')) {
    if (weeks.indexOf(mday.week()) === -1) {
      weeks.push(mday.week());
    }
  }


// Create a range for each week
    let weekWiseData = [];
    let firstWeekDay;
    let lastWeekDay;
    for (let index = 0; index < weeks.length; index++) {
    const weeknumber = weeks[index];

    firstWeekDay = moment().year(year).month(month).week(weeknumber).day(1);
    lastWeekDay = moment().year(year).month(month).week(weeknumber).day(7);
    if ( (weeks.length - 1 ) === index) {
        firstWeekDay = moment().year(year).month(month).week(weeks[index - 1]).day(1);
        firstWeekDay.add(7, 'day');
        lastWeekDay = moment().year(year).month(month).week(weeks[index - 1]).day(6);
        lastWeekDay.add(6, 'day');
     }

     // console.log("First day of week", firstWeekDay, weeknumber);
     // console.log("Last day of week", lastWeekDay, weeknumber);

    if (firstWeekDay.isBefore(firstDay)) {
      firstWeekDay = firstDay;
    }

    if (lastWeekDay.isAfter(endDay)) {
      lastWeekDay = endDay;
    }

   // document.write("<br>week number: " + index + " day: " + firstWeekDay.format("DD-MM-YYYY") + " to " + lastWeekDay.format("DD-MM-YYYY"))
   // weekRange = moment.range(firstWeekDay, lastWeekDay)
    const str = firstWeekDay.format('DD-MM-YYYY').toString();
    if (index === 0) {
       add = str.startsWith('01');
    }

    weekWiseData.push({start:  firstWeekDay.format('YYYY-MM-DD'), end: lastWeekDay.format('YYYY-MM-DD')});
//  calendar.push({start:  firstWeekDay.format("DD-MM-YYYY"), end:lastWeekDay.format("DD-MM-YYYY")})


  }

    if (!add) {
    // calendar.push({start:  firstWeekDay.format("DD-MM-YYYY"), end:lastWeekDay.format("DD-MM-YYYY")})
    const firstDateOfMonth =  firstWeekDay.format('YYYY-MM-DD').toString();
    const day = firstDateOfMonth.slice(0, 8);
    const finalFirstDate =  day + '01';
    weekWiseData.push({start:  finalFirstDate, end: finalFirstDate});
    }

    console.log(weekWiseData);
    weekWiseData = this.pipe.transform(weekWiseData, 'start', true);
    return weekWiseData;
  }


}
